import React from 'react'

interface DocumentNoteProps {
  width?: string | number
  height?: string | number
  fill?: string
}

export const DocumentNote: React.FC<DocumentNoteProps> = ({
  width = 21,
  height = 21,
  fill = '#282828'
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Document note icon"
  >
    <path
      d="M7.16665 13.8327H13.8333V15.4993H7.16665V13.8327ZM7.16665 10.4993H13.8333V12.166H7.16665V10.4993ZM12.1666 2.16602H5.49998C4.58331 2.16602 3.83331 2.91602 3.83331 3.83268V17.166C3.83331 18.0827 4.57498 18.8327 5.49165 18.8327H15.5C16.4166 18.8327 17.1666 18.0827 17.1666 17.166V7.16602L12.1666 2.16602ZM15.5 17.166H5.49998V3.83268H11.3333V7.99935H15.5V17.166Z"
      fill={fill}
    />
  </svg>
)

export default DocumentNote
